import { ReactComponent as INSTAGRAM } from '../../assets/Instagram.svg';
import { ReactComponent as FACEBOOK } from '../../assets/Facebook.svg';

const Footer = () => {
    return (
        <div className="footer p-2 mt-5" style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 500, minHeight: "250px" }}>
            <div className="d-flex justify-content-center">
            <div
                className="m-5 container h-100 d-flex flex-column justify-content-between"
                style={{ minHeight: "150px" }}
            >
                <div className="d-flex w-100 justify-content-between">
                        <div>
                            <p>Home</p>
                            <p>FAQ's</p>
                            <p>Contact us</p>
                            <p>Reviews</p>
                        </div>
                       
                    <div className="d-flex flex-column align-items-end justify-content-start">
                        <div className="mt-3">
                            <INSTAGRAM style={{ height: 40, marginRight: "1rem" }} />
                            <FACEBOOK style={{ height: 40 }} />
                        </div>
                    </div>
                </div>
                <div className="d-flex w-100 justify-content-center"
                    style={{ fontFamily: 'Montserrat, sans-serif', fontSize: "0.7rem" }} >
                    <p>
                        &copy; FairSplit 2025
                    </p>
                </div>
                </div>
            </div>
        </div>
    );
};

export default Footer;
